export const approvalStatuses = {
  ALL_VIDEOS: {
    TYPE: null,
    DESCRIPTION: 'dashboard.video_list.all_videos',
  },
  PRE_EXISTED: {
    TYPE: 0,
    DESCRIPTION: 'review.status.pre_existed',
  },
  CONCEPT: {
    TYPE: 1,
    DESCRIPTION: 'review.status.concept',
  },
  IN_REVIEW: {
    TYPE: 2,
    DESCRIPTION: 'review.status.in_review',
  },
  DECLINED: {
    TYPE: 3,
    DESCRIPTION: 'review.status.decline',
  },
  APPROVED: {
    TYPE: 4,
    DESCRIPTION: 'review.status.approved',
  },
};

export const approvalStatusesForFilter = {
  ALL_VIDEOS: {
    TYPE: null,
    DESCRIPTION: 'dashboard.video_list.all_videos',
  },
  CONCEPT: {
    TYPE: 1,
    DESCRIPTION: 'review.status.concept',
  },
  IN_REVIEW: {
    TYPE: 2,
    DESCRIPTION: 'review.status.in_review',
  },
  DECLINED: {
    TYPE: 3,
    DESCRIPTION: 'review.status.decline',
  },
  APPROVED: {
    TYPE: 4,
    DESCRIPTION: 'review.status.approved',
  },
};

export const approvalStatusesForReviewer = {
  IN_REVIEW: {
    TYPE: 2,
    DESCRIPTION: 'review.status.in_review',
  },
  APPROVED: {
    TYPE: 4,
    DESCRIPTION: 'review.status.approved',
  },
};
